module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }